import { render, staticRenderFns } from "./desktop-client.vue?vue&type=template&id=15629102&scoped=true"
import script from "./desktop-client.vue?vue&type=script&lang=js"
export * from "./desktop-client.vue?vue&type=script&lang=js"
import style0 from "./desktop-client.vue?vue&type=style&index=0&id=15629102&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15629102",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15629102')) {
      api.createRecord('15629102', component.options)
    } else {
      api.reload('15629102', component.options)
    }
    module.hot.accept("./desktop-client.vue?vue&type=template&id=15629102&scoped=true", function () {
      api.rerender('15629102', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/desktop/desktop-client.vue"
export default component.exports